export default {
	namespaced: true, // 当 namespaced 设置为true之后引入在index中的时候不会与其他相同名称的数据或方法发生冲突
	state: {
        outside: 0,
        inside: 0,
        imgSrc: "",
	},
	mutations: {
		setOutside(state,num){
            state.outside = num;
        },
        setInside(state,num){
            state.inside = num;
        },
        setImgSrc(state,str){
            state.imgSrc = str;
        },
    },
    actions: {
        setOutsideAndInside({commit},option){
             // console.log(option);
            if(option.outside){
                commit("setOutside",option.outside)
            }
            if(option.inside){
                commit("setInside",option.inside)
            }
        },
    }
}